export const ORTHO_SYSTEM_COMPLIANCE_CLAUSES = {
  metal_conventional: [
    "Patient must attend all scheduled adjustment visits and must not remove, cut, or adjust brackets, wires, elastics, or other appliances without clinic instruction.",
    "Patient must avoid hard, sticky, or brittle food that may detach brackets or deform wires, and must report loose brackets, poking wires, or appliance breakage promptly.",
    "Patient understands that missed visits, poor hygiene, broken appliances, or failure to follow elastic and care instructions may extend treatment time or affect final results.",
  ],
  self_ligating: [
    "Patient must attend all scheduled adjustment visits and must not open, close, or tamper with self-ligating clips or brackets without clinic instruction.",
    "Patient must avoid food or habits that may damage clips, wires, or brackets, and must report appliance breakage promptly.",
    "Patient understands that missed visits, poor hygiene, broken appliances, or failure to follow care instructions may extend treatment time or affect final results.",
  ],
  clear_aligner: [
    "Patient must wear aligners for the prescribed daily wear time and must change trays only according to clinic instruction.",
    "Patient must keep aligners clean, avoid eating or drinking colored beverages while wearing them, and store aligners properly when removed.",
    "Patient understands that missed wear time, lost aligners, poor hygiene, or failure to follow tray schedules may extend treatment time or affect final results.",
  ],
};

export function orthoSystemClauseKey(systemName) {
  const value = String(systemName || "").toLowerCase();
  if (value.includes("aligner") || value.includes("invisalign") || value.includes("clearcorrect")) return "clear_aligner";
  if (value.includes("self")) return "self_ligating";
  return "metal_conventional";
}

export function orthoSystemClauses(systemName) {
  return ORTHO_SYSTEM_COMPLIANCE_CLAUSES[orthoSystemClauseKey(systemName)]
    || ORTHO_SYSTEM_COMPLIANCE_CLAUSES.metal_conventional;
}
